const DAY_MS = 86_400_000
export const MAX_SEGMENTS = 30

// Local calendar-day number; DST-safe because it goes through UTC midnight.
const dayNum = (ms: number) => {
  const d = new Date(ms)
  return Math.round(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / DAY_MS)
}

export type TimeMeter = {
  total: number
  /** Today's 1-based day within the span, clamped to total. */
  day: number
  /** Segments filled (today counts as elapsed). */
  filled: number
  /** 0..1, share of the span elapsed; drives the bar and the partial strike. */
  ratio: number
  tone: 'normal' | 'amber' | 'red'
  overdue: boolean
  /** One segment per day when false; one continuous bar with `ticks` when true. */
  continuous: boolean
  /** Weekly tick positions (0..1) for the continuous bar. */
  ticks: number[]
}

export function timeMeter(startMs: number, dueMs: number, nowMs: number): TimeMeter {
  const due = dayNum(dueMs)
  const start = Math.min(dayNum(startMs), due)
  const today = dayNum(nowMs)
  const total = due - start + 1
  const overdue = today > due
  const day = Math.min(Math.max(today - start + 1, 1), total)
  const filled = overdue ? total : day
  const ratio = filled / total
  const continuous = total > MAX_SEGMENTS
  const ticks: number[] = []
  if (continuous) for (let d = 7; d < total; d += 7) ticks.push(d / total)
  return {
    total,
    day,
    filled,
    ratio,
    tone: overdue ? 'red' : ratio >= 0.75 ? 'amber' : 'normal',
    overdue,
    continuous,
    ticks,
  }
}

export function showsTimeMeter(t: {
  dueDate?: number | null
  completedAt?: number | null
  status?: string
  isHabit?: boolean
  recursPeriod?: string | null
  recurs?: boolean
}): boolean {
  return (
    t.dueDate != null &&
    !t.completedAt &&
    t.status !== 'done' &&
    !t.isHabit &&
    !t.recursPeriod &&
    !t.recurs
  )
}
